// extracted by mini-css-extract-plugin
module.exports = {"budgetModal":"styles-module--budgetModal--2MGMy","title":"styles-module--title--3hAJa","amount":"styles-module--amount--jWzyr","subtitle":"styles-module--subtitle--2QTQY"};